import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import logo from '../logo.svg';

function Testimonios() {
    return (
        <div> 
            <div className='container-fluid bg-secondary-subtle'>
                <div className="container p-5 text-start">
                    <div className="row align-items-center">
                        <div className="col">
                            <h1>Lorem Ipsum</h1>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
                        </div>
                        <div className="col">
                            <img src={logo} className="card-img" alt="..." />
                        </div>
                    </div>
                </div>
            </div>

            <div className='container-fluid rgb-color-border'>
                <div className="container p-5 text-start">
                    <div className="row align-items-center">
                        <div className="col">
                            <img src={logo} className="card-img" alt="..." />
                        </div>
                        <div className="col">
                            <h1>Lorem Ipsum</h1>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className='container-fluid rgb-color-border'>
                <div className="container p-5 text-start">
                    <div className="row align-items-center">
                        <div className="col">
                            <img src={logo} className="card-img" alt="..." />
                        </div>
                        <div className="col">
                            <h1>Lorem Ipsum</h1>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className='container-fluid rgb-color-border'>
                <div className="container p-5 text-start">
                    <div className="row align-items-center">
                        <div className="col">
                            <img src={logo} className="card-img" alt="..." />
                        </div>
                        <div className="col">
                            <h1>Lorem Ipsum</h1>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
}

export default Testimonios;